module.exports = __webpack_public_path__ + "img/404.8a293ed9.jpg";